import React, { useEffect, useMemo } from 'react'
import styles from '../vendorsListPage.module.scss'
import TextArea from '../../../components/atoms/textarea/TextArea'
import InputCustom from '../../../components/atoms/input/InputCustom'
import PackageSelection from './PackageSelection'
import styles2 from './Package.module.scss'
import { formatCommonAmount } from '../../../util/formatAmount'
import { Typography } from '@mui/material'

function BudgetRange({
	selectedKazoo,
	setSelectedKazoo,
	setSelectedPackage,
	selectedPackage,
}) {
	const userBudget = selectedKazoo?.userBudget || ''
	useEffect(() => {
		const val = String(userBudget).replace(/[^0-9.]/g, '')
		setSelectedKazoo((prev) => ({ ...prev, userBudget: parseFloat(val) }))
	}, [selectedKazoo?.userBudget])

	const totalPrice = useMemo(() => {
		if (!selectedPackage) return 0

		const packagePrice = parseFloat(selectedPackage?.price) || 0

		const selectedAddOnsTotal =
			selectedPackage?.selectedAddOns?.reduce((sum, addonId) => {
				const addon = selectedPackage?.addOnsIds?.find(
					(a) => a?._id === addonId
				)
				const addonPrice = parseFloat(addon?.price) || 0
				const quantity = !!addon?.quantity
					? parseInt(addon?.quantity)
					: 1
				const minQuantity = !!addon?.minQuantity
					? parseInt(addon?.minQuantity)
					: 1
				const qty = quantity > minQuantity ? quantity : minQuantity
				return sum + addonPrice * qty
			}, 0) || 0

		return packagePrice + selectedAddOnsTotal
	}, [selectedPackage])

	return (
		<div className={styles.VendorsListModalBody}>
			{/* {!selectedKazoo?.userBudget && !selectedPackage && (<p className={styles.warningTextContainer}><img src="/images/info-circle.svg" alt="info" height={16} width={16} /><span>Please fill a Budget or select a Package</span></p>)} */}
			<PackageSelection
				selectedPackage={selectedPackage}
				setSelectedPackage={setSelectedPackage}
				setSelectedKazoo={setSelectedKazoo}
			/>

			<div className="">
				<label htmlFor="Budget" className={styles.label}>
					Budget
				</label>
				<InputCustom
					value={!!userBudget ? userBudget : ''}
					data={selectedKazoo}
					setDataFunction={setSelectedKazoo}
					type="number"
					id="userBudget"
					name="userBudget"
					inputProps={{ min: 0 }}
				/>
			</div>

			<div className="">
				<label htmlFor="Service Requirements" className={styles.label}>
					Service Requirements
				</label>
				<TextArea
					label="Service Requirements"
					placeholder="Enter Service Requirements"
					value={selectedKazoo?.serviceRequirements || ''}
					onChange={(e) => {
						setSelectedKazoo((prev) => ({
							...prev,
							serviceRequirements: e.target.value,
						}))
					}}
				/>
			</div>
			{selectedPackage && (
				<div className={styles2.totalPriceWrp}>
					<Typography
						variant="body2"
						className={styles2.totalPriceWrpText}
					>
						{selectedPackage?.selectedAddOns?.length > 0
							? 'Package & Add-ons Price'
							: 'Package Price'}
					</Typography>
					<Typography
						variant="body2"
						className={styles2.totalPriceWrpValue}
					>
						Total: {formatCommonAmount(totalPrice)}
					</Typography>
				</div>
			)}
		</div>
	)
}

export default BudgetRange
